/**
 * Öppnar en betalningssida (Stripe) på ett sätt som fungerar även när sajten
 * visas inuti en inbäddad ram, där popupfönster och vanlig navigering ofta
 * blockeras. Ordningen är: förbokad flik → ny flik → toppfönstret → länk.
 */

export type PaymentWindow = Window | null;

/** Öppnar en tom flik synkront direkt i klicket, innan serveranropet. */
export function reservePaymentWindow(): PaymentWindow {
  try {
    const w = window.open("", "_blank");
    if (w) {
      w.document.title = "Öppnar säker betalning…";
      w.document.body.textContent = "Öppnar säker betalning…";
    }
    return w;
  } catch {
    return null;
  }
}

/**
 * Skickar användaren till adressen. Returnerar false om inget fönster kunde
 * öppnas – då bör anroparen visa en klickbar länk i stället.
 */
export function goToPayment(url: string, reserved: PaymentWindow): boolean {
  if (reserved && !reserved.closed) {
    try {
      reserved.location.href = url;
      return true;
    } catch {
      /* fortsätt nedan */
    }
  }

  try {
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (w) return true;
  } catch {
    /* fortsätt nedan */
  }

  // Inbäddad ram: försök lämna ramen helt.
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return true;
    }
  } catch {
    /* korsdomän – går inte */
  }

  try {
    window.location.assign(url);
    return true;
  } catch {
    return false;
  }
}

export function closePaymentWindow(w: PaymentWindow) {
  try {
    w?.close();
  } catch {
    /* ignorera */
  }
}
